import * as Sentry from '@sentry/react';

// When attempting to connect an account and providing an invalid Tread ID, the API will return
// either a 400 (bad shaped Tread ID) or a 404 (no matching company for the given Tread ID).
export function ignoreCompanyByTreadIdNotFoundWhenConnectingAccountRule(
  event: Sentry.ErrorEvent,
) {
  const is400ErrorReponse = event.contexts?.response?.status_code === 400;
  const is404ErrorReponse = event.contexts?.response?.status_code === 404;
  const isGETRequest = event.request?.method === 'GET';

  const requestUrl = event.request?.url ?? '';
  const regexp = /v1\/companies\/tread_id\/(.+)$/;
  const isFetchingCompanyByTreadId = regexp.test(requestUrl);

  return (
    (is400ErrorReponse || is404ErrorReponse) && isGETRequest && isFetchingCompanyByTreadId
  );
}
